export default __webpack_public_path__ + "static/media/Battle_on_the_Boardwalk_LE.6923fb39.jpg";